export const numericFormat = (evt, data, max_length) => {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    let keys = [46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
    let validIndex = keys.indexOf(charCode);
    if (validIndex === -1 || String(data).length > max_length) {
        event.preventDefault();
    }
}

let finalEnlishToMayanmarNumber = {
    '1': "၁",
    '2': "၂",
    '3': "၃",
    '4': "၄",
    '5': "၅",
    '6': "၆",
    '7': "၇",
    '8': "၈",
    '9': "၉",
    '0': "၀",
};

String.prototype.getDigitMayanmarFromEnglish = function () {
    let retStr = this;
    for (let x in finalEnlishToMayanmarNumber) {
        retStr = retStr.replace(new RegExp(x, 'g'), finalEnlishToMayanmarNumber[x]);
    }

    return retStr;
};

export const convertEnglishToMayanmar = (data) => {
    let number = String(data.number);
    if (data.lang === 'en') {
        return data.number;
    }

    return number.getDigitMayanmarFromEnglish();
}
